
export type DiagnosticStatus = 'Pending' | 'In process' | 'Reported' | 'Critical' | 'Verified'

export interface DiagnosticWorkItem {
  id: string
  patient: string
  mrn: string
  order: string
  service: string
  source: string
  collectedOrScheduled: string
  tat: string
  status: DiagnosticStatus
  owner: string
}

export interface ChargeService {
  code: string
  name: string
  domain: 'Laboratory' | 'Radiology' | 'Cardiology'
  standard: string
  turnaround: string
  rate: number
  costCenter: string
  revenueGl: string
  active: boolean
}

export const laboratoryWorklist: DiagnosticWorkItem[] = [
  { id: 'LAB-260719-1831', patient: 'Bilal Ahmed Khan', mrn: 'MRN-0051902', order: 'STAT blood gas + electrolytes', service: 'Emergency Chemistry', source: 'ER Resuscitation', collectedOrScheduled: 'Collected 14:18', tat: '12 min remaining', status: 'Critical', owner: 'A. Zainab' },
  { id: 'LAB-260719-1833', patient: 'Rukhsana Bibi', mrn: 'MRN-0049124', order: 'High-sensitivity Troponin I', service: 'Cardiac markers', source: 'Emergency Major Care', collectedOrScheduled: 'Received 14:23', tat: '18 min remaining', status: 'In process', owner: 'Analyzer CH-02' },
  { id: 'LAB-260719-1818', patient: 'Ayesha Rahman', mrn: 'MRN-0048213', order: 'CBC + renal profile', service: 'Hematology', source: 'Cardiology Ward', collectedOrScheduled: 'Collected 13:52', tat: 'Ready for verification', status: 'Reported', owner: 'M. Raza' },
  { id: 'LAB-260719-1805', patient: 'Fatima Zafar', mrn: 'MRN-0043019', order: 'Glucose challenge test', service: 'Clinical chemistry', source: 'Women’s Health Centre', collectedOrScheduled: 'Scheduled 15:00', tat: 'Not started', status: 'Pending', owner: 'Collection desk' },
]

export const radiologyWorklist: DiagnosticWorkItem[] = [
  { id: 'RAD-260719-0742', patient: 'Tariq Mehmood', mrn: 'MRN-0050317', order: 'CT head stroke protocol', service: 'CT', source: 'Emergency Major Care', collectedOrScheduled: 'Acquired 14:16', tat: '4 min to breach', status: 'Critical', owner: 'Dr. S. Raza' },
  { id: 'RAD-260719-0738', patient: 'Bilal Ahmed Khan', mrn: 'MRN-0051902', order: 'Portable chest X-ray', service: 'X-Ray', source: 'ER Resuscitation', collectedOrScheduled: 'Acquired 14:11', tat: 'Ready for report', status: 'In process', owner: 'Dr. R. Ali' },
  { id: 'RAD-260719-0724', patient: 'Ayesha Rahman', mrn: 'MRN-0048213', order: 'Echocardiography correlation CT', service: 'CT coronary', source: 'Cardiology Ward', collectedOrScheduled: 'Scheduled 16:30', tat: 'Future slot', status: 'Pending', owner: 'CT-01' },
  { id: 'RAD-260719-0706', patient: 'Zara Sheikh', mrn: 'MRN-0055120', order: 'Breast ultrasound', service: 'Ultrasound', source: 'OPD', collectedOrScheduled: 'Reported 13:40', tat: 'Within target', status: 'Verified', owner: 'Dr. H. Ahmed' },
]

export const cardiologyWorklist: DiagnosticWorkItem[] = [
  { id: 'CARD-260719-0198', patient: 'Rukhsana Bibi', mrn: 'MRN-0049124', order: '12-lead ECG + STEMI pathway', service: 'ECG', source: 'Emergency Major Care', collectedOrScheduled: 'ECG captured 14:12', tat: 'Cardiologist review', status: 'Critical', owner: 'Dr. Imran Sethi' },
  { id: 'CARD-260719-0195', patient: 'Ayesha Rahman', mrn: 'MRN-0048213', order: 'Transthoracic echocardiogram', service: 'ECHO', source: 'Cardiology Ward', collectedOrScheduled: 'Study complete 13:50', tat: 'Structured draft ready', status: 'Reported', owner: 'Dr. Imran Sethi' },
  { id: 'CARD-260719-0187', patient: 'Fatima Zafar', mrn: 'MRN-0043019', order: 'Holter analysis', service: 'Holter', source: 'OPD', collectedOrScheduled: 'Device returned 12:10', tat: 'Pending analysis', status: 'In process', owner: 'Cardiac tech' },
]

export const serviceCharges: ChargeService[] = [
  { code: 'LAB-CBC-001', name: 'Complete blood count', domain: 'Laboratory', standard: 'LOINC 57021-8', turnaround: '90 min', rate: 1250, costCenter: 'CC-LAB-001', revenueGl: '4100-110', active: true },
  { code: 'LAB-TNI-002', name: 'High-sensitivity Troponin I', domain: 'Laboratory', standard: 'LOINC 49563-0', turnaround: '45 min STAT', rate: 4200, costCenter: 'CC-LAB-001', revenueGl: '4100-110', active: true },
  { code: 'RAD-CTH-101', name: 'CT head stroke protocol', domain: 'Radiology', standard: 'CPT 70450', turnaround: '20 min STAT', rate: 12500, costCenter: 'CC-RAD-001', revenueGl: '4100-120', active: true },
  { code: 'CARD-ECHO-301', name: 'Transthoracic echocardiogram', domain: 'Cardiology', standard: 'CPT 93306', turnaround: '4 hr', rate: 8500, costCenter: 'CC-CARD-DX', revenueGl: '4100-130', active: true },
]

export const diagnosticTrend = [
  { day: 'Mon', laboratory: 892, radiology: 241, cardiology: 76 },
  { day: 'Tue', laboratory: 914, radiology: 256, cardiology: 82 },
  { day: 'Wed', laboratory: 876, radiology: 238, cardiology: 71 },
  { day: 'Thu', laboratory: 956, radiology: 278, cardiology: 88 },
  { day: 'Fri', laboratory: 981, radiology: 289, cardiology: 93 },
  { day: 'Sat', laboratory: 744, radiology: 196, cardiology: 61 },
]
